/* eslint-disable import/prefer-default-export */
/**
 * GraphQL operations for Sweepstakes (backend: sweepstakes table with open_date, close_date, sweepstakes_tag).
 * Frontend hardcodes sweepstakes_tag (e.g. snack-madness-2026) to query the correct sweepstakes.
 * Query/mutation names and types must match backend schema (sweepstakes.graphql).
 */
import gql from 'graphql-tag';

/** Fetch sweepstakes by tag; returns openDate, closeDate (UTC). No auth required. */
export const SWEEPSTAKES_QUERY = gql`
  query SweepstakesByTag($sweepstakesTag: String!) {
    sweepstakes(sweepstakesTag: $sweepstakesTag) {
      id
      sweepstakesTag
      openDate
      closeDate
      status
    }
  }
`;

/** Submit one entry per user; backend uses auth customer_id and records entry_date. */
export const SUBMIT_SWEEPSTAKES_ENTRY_MUTATION = gql`
  mutation SubmitSweepstakesEntry($input: SubmitSweepstakesEntryInput!) {
    submitSweepstakesEntry(input: $input) {
      success
      message
    }
  }
`;

/** Check if current user has already entered this sweepstakes. Requires auth. Returns plain Boolean. */
export const SWEEPSTAKES_ENTRY_STATUS_QUERY = gql`
  query SweepstakesEntryStatus($sweepstakesTag: String!) {
    sweepstakesEntryStatus(sweepstakesTag: $sweepstakesTag)
  }
`;
